<script lang="ts">
    import { marked } from "marked";
    import DOMPurify from "dompurify";
    import BotTextMessage from "./BotTextMessage.svelte";

    let { message, url }: { message: string; url: string } = $props();

    const WELCOME_LIST_ENTRY_MESSAGE = "Moin, ich berate dich gerne zu Produkten.";

    const sanitizedMessage = $derived(
        DOMPurify.sanitize(marked.parseInline(message || "", { async: false }) as string)
    );

</script>

<div class="list-entry-container">
    <div class="list-entry">
        <BotTextMessage message={WELCOME_LIST_ENTRY_MESSAGE} />

        <oc-chip-v2 class="chip" base64-href={btoa(url)} icon="sparkles" over-color size={"100"} data-tr-v1-tr-next-page-impression={'{"san_ChatBotInteraction": ["listElement_open"], "wk.san_ChatBotEntry": ["listElement"] }'} data-tr-v1.track="click">
            {@html sanitizedMessage}
        </oc-chip-v2>
    </div>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .list-entry-container {
    padding: tokens.$oc-semantic-spacing-25 0;

    .list-entry {
      padding: tokens.$oc-semantic-spacing-75 tokens.$oc-semantic-spacing-75 tokens.$oc-semantic-spacing-100;
      background-color: tokens.$oc-base-color-purple-70;
      border-radius: tokens.$oc-semantic-border-radius-200;
      font: tokens.$oc-semantic-font-copy-100;
    }

    .chip {
      padding-top: tokens.$oc-semantic-spacing-50;
    }
  }
</style>
